import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import MetadataWrapper from 'components/metadata-wrapper'
import CopyToClipboard from 'components/copy-to-clipboard'
import WidgetMakerOption from './widget-maker-option'

import styles from './widget-maker.css'

const formatParagraph = `Choose how you’d like the widget to appear on your website.
<ul>
<li>Calendar: a calendar view of available dates, suitable for long running events</li>
<li>Short list: a list of up to 6 ticket options, suitable for smaller widgets</li>
<li>Full list: a full list of all ticket options, suitable for larger widgets</li>
<li>Compact: a hybrid list/calendar view, suitable for larger more functional widgets</li>
</ul>`

const integrationTypeParagraph = `Choose the type of widget you want to integrate into your website. The dynamic
widget uses JavaScript to automatically adjust its height based on where you place it on your website. The static
widget has a fixed height, so while it's less flexible, it is easier to integrate as it doesn't require JavaScript.`

const WidgetMaker = ({ format, onChange, snippet, type, width }) => (
  <div styleName="widget-maker">
    <MetadataWrapper label="Width">
      <p styleName="paragraph">
        The default "100%" makes the widget stretch horizontally to fit the container. If you need a fixed width, set
        it in pixels, e.g. "700px".
      </p>
      <input
        type="text"
        value={width}
        onChange={e => onChange('width', e.target.value)}
        styleName="input"
      />
    </MetadataWrapper>

    <WidgetMakerOption
      label="Format"
      paragraph={formatParagraph}
      value={format}
      name="format"
      options={['short-list', 'full-list', 'calendar', 'compact']}
      onChange={onChange}
    />

    <WidgetMakerOption
      label="Integration type"
      paragraph={integrationTypeParagraph}
      value={type}
      name="type"
      options={['dynamic', 'static']}
      onChange={onChange}
    />

    <MetadataWrapper label="Code">
      <CopyToClipboard snippet={snippet} />
    </MetadataWrapper>
  </div>
)

WidgetMaker.propTypes = {
  format: PropTypes.string,
  onChange: PropTypes.func,
  snippet: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.string,
}

export default CSSModules(WidgetMaker, styles)



/** WEBPACK FOOTER **
 ** ./src/components/widget-maker/widget-maker.js
 **/